import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import FPButtonMenu from 'UI/components/molecules/FPButtonMenu';

/**
 * The ⋮ menu of the header, with the V1 configuration. FPButtonMenu hides itself when no
 * item is visible and skips items with `visible: false`. Falsy entries (an item a hook
 * did not produce) are dropped here so the builders can stay plain arrays.
 * @param {Object} props
 * @param {Array<{ title: string, action: () => void, visible: boolean }>} props.items
 *   Built by build<Entity>MenuItems
 */
export const ProfileMenu = ({ items }) => (
  <Grid item>
    <FPButtonMenu
      isIconButton
      menuItems={items.filter(Boolean)}
      tooltipProps={{ title: strings.inventoryProfiles.menu.options }}
      variant="outlinePrimary"
    />
  </Grid>
);
